import React from 'react';
import { AccountTree, Map } from '@mui/icons-material';

const HybridMapTreeIcon = () => (
  <span
    style={{
      position: 'relative',
      width: 20,
      height: 20,
      display: 'inline-flex',
      alignItems: 'center',
      justifyContent: 'center',
    }}
  >
    <Map style={{ fontSize: 20 }} />
    <AccountTree
      style={{
        fontSize: 12,
        position: 'absolute',
        right: -2,
        bottom: -2,
        background: '#fff',
        borderRadius: '50%',
      }}
    />
  </span>
);

export { HybridMapTreeIcon };
